module.exports = __webpack_public_path__ + "static/algolia.33f29a17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/algolia.jpg
// module id = 837
// module chunks = 73261030922168